module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/meal_kit-checkout@2x-74cc2441cc4f53a3aa76a84711341992.jpg";